import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as LocationActions from './location.actions';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { Location } from '@gridscale/gsclient-js';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';
import { loginSuccess } from '../auth/auth.actions';

@Injectable()
export class LocationEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly apiPublic: PublicPartnerApiService
  ) {}

  loadLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        LocationActions.loadLocations, 
        LocationActions.patchLocationSuccess, 
        loginSuccess
      ),
      concatMap((action) =>
        this.apiPublic
          .get<{ locations: Record<string, Partial<Location>> }>(
            '/partners/##CURRENT_PARTNER_UUID##/locations'
          )
          .pipe(
            map((result) => {
              return LocationActions.loadLocationsSuccess({
                locations: _.toArray(result.locations),
              });
            }),
            catchError((error) =>
              of(
                LocationActions.loadLocationsFailure({ error }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );

  loadLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        LocationActions.loadLocationByUuid, 
        LocationActions.patchLocationSuccess
      ),
      concatMap((action) =>
        this.apiPublic
          .get<{ location: Partial<Location> }>(
            '/partners/##CURRENT_PARTNER_UUID##/locations/' +
              action.location_uuid
          )
          .pipe(
            map((result) => {
              return LocationActions.loadLocationSuccessByUuid({
                location: result.location,
                location_uuid: action.location_uuid,
              });
            }),
            catchError((error) =>
              of(
                LocationActions.loadLocationFailureByUuid({
                  location_uuid: action.location_uuid,
                  error,
                }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );


  patchLocation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        LocationActions.patchLocation
      ),
      concatMap((action) =>
        this.apiPublic
          .patch<{ location: Partial<Location> }>(
            '/partners/##CURRENT_PARTNER_UUID##/locations/' +
              action.location_uuid, 
              action.data
          )
          .pipe(
            map(() => {
              return LocationActions.patchLocationSuccess({
                location_uuid: action.location_uuid,
                data: action.data,
              });
            }),
            catchError((error) =>
              of(
                LocationActions.patchLocationFailure({
                  location_uuid: action.location_uuid,
                  error,
                }),
                globalFailure({ error })
              )
            )
          )
      )
    )
  );
}
